module.exports = __webpack_public_path__ + "static/media/ai.2a693765.png";